import { Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "sps-card-header",
    templateUrl: "./sps-card-header.component.html",
    encapsulation: ViewEncapsulation.Emulated
})
export class SpsCardHeaderComponent {
    static readonly displayName = "sps-card-header";
    static readonly props = {
        icon: "string",
        title: "string",
    };

    @Input() icon: string;
    @Input() title: string;

    @HostBinding("class.sps-card__header") readonly _classSpsCardHeader = true;
}
